import { PureLightTheme } from "../../../styles/theme";

export const MainBox = {
  mt: 5,
  maxWidth: '736px',
  width: '100%',
  [PureLightTheme.breakpoints.down('md')]: {
    maxWidth: "760px",
    mt: 2,
    padding: "0px 12px",
  },
}

export const SideBox = {
  mt: '16px', 
  position: 'sticky', 
  top: 77, 
  alignSelf: 'flex-start', 
  height: 'calc(100vh - 77px - 16px)', // отступ сверху и снизу 
}

export const StackStyle = {
  justifyContent: 'center',
  gap: 2, 
  padding: '0px 8px', 
  '@media (max-width:1200px)': {
    gap: 1,
  },
  [PureLightTheme.breakpoints.down('md')]: {
    padding: 0, 
  },
}